<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'处方明细'" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div>
      <div class="content_title">费用明细</div>
      <div class="detail">
        <div class="listrow">
          <div class="itemName project_c">项目名</div>
          <div class="count">数量</div>
          <div class="textcolor red price">价格</div>
        </div>

        <div
          class="listrow"
          v-for="(item,key,index) in detailInfo"
           @click="showitemname(item)"
          :key="index"
        >
          <div class="itemName">{{item.ItemName}}</div>
          <div class="count">{{item.Quantity |Finalnum}}{{item.Unit}}</div>
          <div class="price">￥{{item.Price |FinalPrice}}</div>
        </div>
        <div style="text-align:right;margin-right:10px ">总计：￥{{TotalCost}}</div>
      </div>
    
    <div class="pay_list_foot">
      <!-- <van-checkbox v-model="checked" @click="allcheck">全选</van-checkbox> -->
      <div class="pay_button" @click="showqrcode()">打印缴费凭证</div>
    
    </div>
      <van-popup v-model="showcode" round :style="{ height: '40%' , width:'80%'}" closeable>
     <div class="popqrcode_box">
       <div class="popqrcode_text">缴费凭证二维码</div>
       <ProductQrcode :qrcode="qrcodestr" class="popqrcode"/>
     <div class="popqrcode_text">该二维码只能打印一次</div>
     </div>
      </van-popup>
      <van-popup v-model="show" position="top" round
        ><div class="show_tite">项目名称</div>
        <div class="show_name">{{show_name}}</div>
      </van-popup>
      </div>
    </div>
</template>

<script>
import Nav from "@/components/nav.vue";
import ProductQrcode from "@/components/ProductQrcode.vue";
import { Dialog } from "vant";
export default {
  components: {
    Nav,
    ProductQrcode,
  },
  data() {
    return {
      qrcodestr: "",
      showcode: false,
      InvoiceNO: "",
      RegisterNo: "",
      show_name: "",
      show: false,
      detailInfo: [],
      TotalCost:""
    };
  },
  mounted() {
    this.getpayhisdata();
  },
  filters: {
    FinalPrice(price) {
      return Number(price).toFixed(2);
      // console.log(price);
    },
    Finalnum(num) {
      return Number(num).toFixed();
      // console.log(price);
    },
  },
  methods: {
    showqrcode() {
      if(this.$route.query.isPrint==1){
        this.$toast.fail('该单据已打印')
        return
      }
      this.showcode = true;
      this.qrcodestr =
      this.$route.query.InvoiceNO + "," + this.$route.query.RegisterNo;
      console.log(  this.qrcodestr)
    },
    showitemname(item) {
      this.show_name = item.ItemName;
      this.show = true;
    },
    async getpayhisdata() {
      this.TotalCost=this.$route.query.TotalCost
      try {
        this.$showLoad();
        // this.isLoad = true
        let url = "/outpatientfee/paymentDetails";
        let R_data = {
          InvoiceNO: this.$route.query.InvoiceNO,
          RegisterNo: this.$route.query.RegisterNo,
        };
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          R_data,
          (data) => {
            console.log(data);
            this.detailInfo = data.data.data.List.Item;
            // console.log(this.detailInfo);
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.popqrcode_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  width: 100%;
  height: 100%;
  .popqrcode {
    margin-top:5px ;
    margin-bottom: 8px;
  }
  .popqrcode_text {
    color: #ff3f34;
    text-align: center;
    font-size: 16px;
  }
}

.pay_list_foot {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #aaaaaaaa;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 70px;
  .pay_text {
    margin-left: 20px;
    color: #aaaaaa;
    .money {
      color: #e74c3c;
    }
  }
  .pay_button {
    background-color: #5b8df6;
    margin-right: 20px;
    width: 90%;
    margin: 0px auto;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
}
.last_item {
  margin-bottom: 70px;
}
.red {
  color: #e74c3c;
}
.textcolor {
  color: #5b8df6;
}
.main {
  margin: 0;
  padding: 0;
  .top {
    height: 50px;
  }
  .head {
    color: #666666;
    margin-top: 5px;
    padding: 8px;
    background: #f1f2f6;
    border: 1px solid #f1f1f1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    .title {
      flex: 1;
      line-height: 35px;
      font-size: 16px;
      margin-left: 8px;
    }
    .ybpay {
      flex: 1;
      font-size: 16px;
      text-align: center;
      margin-left: 5px;
      margin-right: 5px;
      line-height: 15px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  }
  .list {
    padding: 10px;
    padding-top: 0px;
    display: flex;
    flex-direction: column;
    color: #747d8c;
    margin-bottom: 15px;

    .listrow {
      display: flex;
      font-size: 15px;
      flex-direction: row;
      margin-left: 10px;
      margin-right: 10px;
      justify-content: space-between;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #5b8df6aa;

      .red {
        color: #e74c3c;
      }
    }
  }
  .content_title {
    width: 90%;
    margin: 0px auto;
    color: #5b8df6aa;
    text-align: center;
    font-size: 18px;
    letter-spacing: 10px;
    margin-bottom: 5px;
  }
  .last_item {
    width: 10px;
    height: 1px;
    margin-bottom: 70px;
  }
  .detail {
    .red {
      color: #5b8df6aa;
    }
    color: #747d8c;
    display: flex;
    flex-direction: column;
    width: 95%;
    margin: 0px auto;
    border-top: 3px dashed #a4b0be;
    border-bottom: 3px dashed #a4b0be;
    border-left: 15px dashed #a4b0be;
    border-right: 15px dashed #a4b0be;
    margin-bottom: 20px;
    //   box-shadow: inset 3px 3px #a4b0be;

    .listrow {
      font-size: 15px;
      display: flex;
      flex-direction: row;
      margin-left: 10px;
      margin-right: 10px;
      justify-content: space-between;
      height: 35px;
      line-height: 30px;
      border-bottom: 1px dashed #5b8df6aa;
      .price {
        color: #5b8df6;
        // width: 40px;
        flex: 2;
        text-align: center;
      }
      .count {
        align-items: center;
        align-content: center;
        flex: 2;
        text-align: center;
      }
      .itemName {
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 3;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        // width: 140px;
        //规定段落中的文本不进行换行
      }
      .project_c {
        text-align: center;
      }
    }
  }
}
.foot {
  width: 90%;
  .foot_btn {
    margin: 0px auto;
  }
}
.show_tite {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 25px;
}
.show_name {
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
.van-popup {
  height: 78px;
}
.van-popup--top.van-popup--round {
  border-radius: 0 0 10px 10px;
}
</style>